import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { parseSearch, renderSearch } from 'navigation'

export function useUrlParam(name: string, defaultValue = ''): [string, (value: string | null) => void] {
    const history = useHistory()
    const location = useLocation()
    const value = parseSearch(location.search)[name] ?? defaultValue

    const setValue = useCallback(
        (next: string | null) => {
            const query = parseSearch(history.location.search)
            const cleared = next === null || next === '' || next === defaultValue
            const nextQuery: Record<string, string | undefined> = { ...query, [name]: cleared ? undefined : next }
            const search = renderSearch(nextQuery)
            history.replace({ pathname: history.location.pathname, search: search === '?' ? '' : search })
        },
        [history, name, defaultValue],
    )

    return [value, setValue]
}
